export default __webpack_public_path__ + "static/media/thumb_up.54c19595.svg";